export default "__VITE_ASSET__DNwIj4jc__"